import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-date-picker/dist/DatePicker.css";
import "react-time-picker/dist/TimePicker.css";

import "bootstrap/dist/css/bootstrap.min.css";

import "./index.scss";

import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";

// ResizeObserver fires synchronously across layout reads; deferring avoids Chrome's
// "ResizeObserver loop completed..." which CRA's overlay surfaces as fatal.
(function patchResizeObserverForChartLayout() {
  const Original =
    typeof window !== "undefined" &&
    typeof window.ResizeObserver === "function"
      ? window.ResizeObserver
      : typeof ResizeObserver === "function"
      ? ResizeObserver
      : null;

  if (!Original || window.__ATS_PATCHED_RESIZE_OBSERVER__) return;

  window.__ATS_PATCHED_RESIZE_OBSERVER__ = true;

  window.ResizeObserver = class ResizeObserverPatch extends Original {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
})();

// Chart.js/layout still occasionally trips the benign error above; swallow for dev overlay.
window.addEventListener(
  "error",
  (event) => {
    const msg =
      typeof event?.message === "string"
        ? event.message
        : String(event?.error?.message ?? "");

    if (/ResizeObserver loop/i.test(msg)) {
      event.stopImmediatePropagation?.();
    }
  },
  true
);

const loading = <div>Loading...</div>;

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Suspense fallback={loading}>
      <App />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();